import React from "react";
import { EstadoVacio } from "./base";

// Estado vacío compartido (se usa en ~58 pantallas). Ahora es calmado: sin rojo ni animación.
// Sin props muestra "No hay datos"; las props opcionales (icono, titulo, descripcion, accion)
// pasan a EstadoVacio.
const NoData = (props) => {
  return <EstadoVacio {...props} />;
};

export default NoData;
